export function waitForPrivateImages(root, timeout = 15000) {
  const pending = () => root.querySelector('[data-private-image="true"][aria-busy="true"]');
  if (!pending()) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const observer = new MutationObserver(() => { if (!pending()) { clearTimeout(timer); observer.disconnect(); resolve(); } });
    const timer = setTimeout(() => { observer.disconnect(); reject(new Error('Private images could not be loaded.')); }, timeout);
    observer.observe(root, { attributes: true, subtree: true, childList: true });
  });
}
